import reactRouterDom from "react-router-dom"
import { esBarras, getSegmento } from "./generics"

/**
 * Función hecha con la intención de que se exporte y se utilice sobre todo
 * módulo que requiera realizar una búsqueda por coincidencia de texto.
 * 
 * @param:  input. Texto que ha sido introducido como búsqueda
 *          option. Opciones sobre las que se realizará el filtrado
 * @return: boolean. Indica si input se encuentra en option.
*/
let sanitizerTexto = (input, option) => {
        return  option.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                .trim().toLowerCase().includes(input.normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "").trim().toLowerCase())
}
let  getStatusInv= (value) => {
        const esBarra = esBarras()
        if(value === 0)         return "Borrador"
        else if(value === 1 && !esBarra)    return "Pendiente facturación"
        else if(value === 1 && esBarra)    return "Pendiente cierre de día"
        else if(value === 2)    return "Validar Reconteo"
        else if(value === 3)    return "Procesando"
        else if(value === 4 && !esBarra)    return "Pendiente SAP"
        else if(value === 4 && esBarra)    return "Pendiente procesar"
        else                    return "Finalizado"
}
let  getStatusInvColor= (value) => {
        if(value === 0)         return "#F1C40F";
        else if(value === 1)    return "#fd1b02ff";
        else if(value === 2)    return "#e97132";
        else if(value === 3)    return "#119ed6";
        else if(value === 4)    return "#fd1b02ff";
        else                    return "#000000ff";
}

let esBorradorVencido = (fecha) => {
        const now = new Date()
        const rd = new Date(fecha);

        // Umbral: día siguiente a las 06:00 (en hora local)
        const threshold = new Date(
            rd.getFullYear(),
            rd.getMonth(),
            rd.getDate() + 1,
            9, 0, 0, 0
        );

        return now > threshold;
    }

export {sanitizerTexto, getStatusInv, getStatusInvColor, esBorradorVencido};